import classNames from 'classnames';
import { makeStyles } from 'design-system/styles';
// eslint-disable-next-line restrict-imports/restrict-imports

const GRID_SIZE = 10;

interface VideoWithGridProps {
  url: string;
  onEnded: () => void;
}
/**
 * Specialized component for Twelve Labs use case.
 */
export default function VideoWithGrid(props: VideoWithGridProps) {
  const styles = useStyles();

  function getPos(e: any) {
    const cursor = document.getElementById('cursor');

    if (cursor) {
      const xDiv = e.currentTarget.offsetWidth / GRID_SIZE;
      const yDiv = e.currentTarget.offsetHeight / GRID_SIZE;
      const x = e.clientX - e.currentTarget.getBoundingClientRect().x;
      const y = e.clientY - e.currentTarget.getBoundingClientRect().y;
      const text = `(${Math.floor(x / xDiv)}, ${GRID_SIZE - Math.floor(y / yDiv) - 1})`;
      cursor.innerHTML = text;
      cursor.style.left = `${x}px`;
      cursor.style.top = `${y}px`;
    }
  }

  function stopTracking() {
    const cursor = document.getElementById('cursor');
    if (cursor) cursor.innerHTML = '';
  }

  return (
    <div className={classNames(styles.scrollableDiv)}>
      <div id="cursor" className={classNames(styles.cursor)}></div>
      <table width="90%" cellSpacing="0" cellPadding="0" className={classNames(styles.table)}>
        <tr>
          <td className={classNames(styles.cell)}>&nbsp;</td>
          <td className={classNames(styles.cell)}>&nbsp;</td>
          <td className={classNames(styles.cell)}>&nbsp;</td>
          <td className={classNames(styles.cell)}>&nbsp;</td>
          <td className={classNames(styles.cell)}>&nbsp;</td>
          <td className={classNames(styles.cell)}>&nbsp;</td>
          <td className={classNames(styles.cell)}>&nbsp;</td>
          <td className={classNames(styles.cell)}>&nbsp;</td>
          <td className={classNames(styles.cell)}>&nbsp;</td>
          <td className={classNames(styles.cell)}>&nbsp;</td>
          <td className={classNames(styles.cell)}>&nbsp;</td>
        </tr>
        <tr>
          <td className={classNames(styles.cell)}>9</td>
          <td rowSpan={GRID_SIZE} colSpan={GRID_SIZE}>
            <video
              width="100%"
              className={classNames(styles.video)}
              onMouseMove={getPos}
              onMouseOut={stopTracking}
              controls
              id="video"
              src={props.url}
              onEnded={props.onEnded}
            ></video>
          </td>
        </tr>
        <tr>
          <td className={classNames(styles.cell)}>8</td>
        </tr>
        <tr>
          <td className={classNames(styles.cell)}>7</td>
        </tr>
        <tr>
          <td className={classNames(styles.cell)}>6</td>
        </tr>
        <tr>
          <td className={classNames(styles.cell)}>5</td>
        </tr>
        <tr>
          <td className={classNames(styles.cell)}>4</td>
        </tr>
        <tr>
          <td className={classNames(styles.cell)}>3</td>
        </tr>
        <tr>
          <td className={classNames(styles.cell)}>2</td>
        </tr>
        <tr>
          <td className={classNames(styles.cell)}>1</td>
        </tr>
        <tr>
          <td className={classNames(styles.cell)}>0</td>
        </tr>

        <tr>
          <td className={classNames(styles.cell)}></td>
          <td className={classNames(styles.cell)}>0</td>
          <td className={classNames(styles.cell)}>1</td>
          <td className={classNames(styles.cell)}>2</td>
          <td className={classNames(styles.cell)}>3</td>
          <td className={classNames(styles.cell)}>4</td>
          <td className={classNames(styles.cell)}>5</td>
          <td className={classNames(styles.cell)}>6</td>
          <td className={classNames(styles.cell)}>7</td>
          <td className={classNames(styles.cell)}>8</td>
          <td className={classNames(styles.cell)}>9</td>
        </tr>
      </table>
    </div>
  );
}

const useStyles = makeStyles({
  cell: {
    padding: 8,
    fontSize: 14,
    textAlign: 'center',
  },
  cursor: {
    position: 'absolute',
    zIndex: 100,
    mixBlendMode: 'difference',
    top: 0,
    left: 0,
    fontWeight: 500,
    color: '#6A5DF9',
  },
  scrollableDiv: {
    overflowY: 'auto',
    position: 'relative',
    height: '100%',
    width: '100%',
  },
  table: {
    height: 'auto',
  },
  video: {
    position: 'relative',
  },
});
